import React, { useCallback } from "react";
import { ConnectedProps, connect } from "react-redux";
import { AppDispatch, RootState } from "store";
import { PreliquidationFilter } from "./PreliquidationFilter";
import {
  actions as preliquidationActions,
  preliquidationSelector as preliquidationSelectors,
} from "reducers/preliquidation";
import { PreliquidationParamsMiddlewareType } from "sagas/types/preliquidation";
import {
  PreliquidationFilterContainerPropsType,
  PreliquidationFiltersType,
} from "./types";
import { sessionSelector } from "reducers/session";
import { DEFAULT_COUNTRY } from "hooks/useSession";
import { validationSchemaCO } from "./CO/schema";
import { validationSchemaAR } from "./AR/schema";
import { validationSchemaMX } from "./MX/schema";
import useBasicData from "hooks/useBasicData";
import { FISCAL_NUMBER_LENGTH } from "utils/constants";
import { validationSchemaCL } from "./CL/schema";

const PreliquidationFilterContainer = (
  props: PreliquidationFilterContainerPropsType & ConnectorProps
) => {
  const { regions } = useBasicData(["regions"]);

  const search = (values: PreliquidationFiltersType) => {
    props.resetAllSelected();
    props.getPreliquidations({
      ...values,
      ...props.filtersExtra,
    });
    props.setPreliquidationFilters(values);
  };

  const validationSchema = useCallback(() => {
    if (props.countryCode === "CO") return validationSchemaCO();
    if (props.countryCode === "MX") return validationSchemaMX();
    if (props.countryCode === "CL") return validationSchemaCL();
    return validationSchemaAR();
  }, [props.countryCode]);

  return (
    <PreliquidationFilter
      {...props}
      regions={regions}
      onSubmit={search}
      validationSchema={validationSchema()}
      fiscalNumberLength={FISCAL_NUMBER_LENGTH[props.countryCode]}
      testId={props.testId}
    />
  );
};

const mapStateToProps = (state: RootState) => ({
  filters: preliquidationSelectors(state).filters,
  filtersExtra: preliquidationSelectors(state).filtersExtra,
  countryCode: sessionSelector(state).countryCode || DEFAULT_COUNTRY,
});

const mapDispatchToProps = (dispatch: AppDispatch) => ({
  getPreliquidations: (params: PreliquidationParamsMiddlewareType) => {
    dispatch(preliquidationActions.getPreliquidationsRequest(params));
  },
  setPreliquidationFilters: (filters: PreliquidationFiltersType) => {
    dispatch(preliquidationActions.setPreliquidationFilters(filters));
  },
  reset: () => {
    dispatch(preliquidationActions.reset());
  },
  resetAllSelected: () => {
    dispatch(preliquidationActions.resetAllSelected());
  },
  setCollapseTable: (collapse: boolean) => {
    dispatch(preliquidationActions.setCollapseTable(collapse));
  },
});

const connector = connect(mapStateToProps, mapDispatchToProps);

type ConnectorProps = ConnectedProps<typeof connector>;

export default connector(PreliquidationFilterContainer);
